import React, { Component } from 'react';
import axios from 'axios';
import htmlToDocx from 'html-docx-js/dist/html-docx';
import saveAs from 'file-saver';
import 'react-quill/dist/quill.snow.css';

class AdibApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            originalData: [],
            data: [],
            search: '',
            shortcode: '',
            username: '',
            loading: false,
            activeCell: { id: 0, mo: false, mt: false },
        };
        this.encodedString = Buffer.from("admin:Mohannad@5679").toString("base64");
    }

    fetchData = async (url) => {
        this.setState({ loading: true });
        try {
            const response = await axios.get(url, {
                headers: { 'Authorization': 'Basic ' + this.encodedString },
            });
            this.setState({
                originalData: response.data.results,
                data: response.data.results,
                loading: false
            });

            // Save to local storage
            localStorage.setItem('data', JSON.stringify(response.data.results));
        } catch (error) {
            console.error('Error fetching data:', error);
            this.setState({ loading: false });
        }
    };


    componentDidMount() {
        const savedData = localStorage.getItem('data');
        if (savedData) {
            const parsedData = JSON.parse(savedData);
            this.setState({
                originalData: parsedData,
                data: parsedData
            });
        } else {
            this.fetchData('https://api2.ahlamkom.net/MOMsgCurrentAdib/');
        }
    }


    searchLocal = () => {
        const searchWords = this.state.search.split(',');

        const filteredData = this.state.originalData.filter((item) => {
            const wordsInMoMessage = this.state.search && item.mo_message && searchWords.every((word) =>
                item.mo_message.includes(word)
            );
            const wordsInMtReplyMsg = this.state.search && item.mt_reply_msg && searchWords.every((word) =>
                item.mt_reply_msg.includes(word)
            );

            const moshortcodeString = item.moshortcode ? item.moshortcode.toString() : '';
            const replyusernameString = item.replyusername ? item.replyusername : '';

            return (
                (!this.state.search || wordsInMoMessage || wordsInMtReplyMsg) &&
                (!this.state.shortcode || moshortcodeString.includes(this.state.shortcode)) &&
                (!this.state.username || replyusernameString.includes(this.state.username))
            );
        });

        this.setState({ data: filteredData });
    };
    geturl = () => {
        const encodedSearch = encodeURIComponent(this.state.search);

        let url = `https://api2.ahlamkom.net/MOMsgCurrentAdib/?`
        if (this.state.shortcode === "") {

        } else {
            url = url + `ShortCode=${this.state.shortcode}&`
        }
        if (this.state.username === '') {

        } else {
            url = url + `ReplyUsername=${this.state.username}&`
        }
        if (this.state.search === '') {

        } else {
            url = url + `MO_MessageF=${encodedSearch}`
        }
        return url
    }
    searchApi = async () => {

        this.fetchData(
            this.geturl()
        );
    };
    searchApiBK = async () => {
        this.fetchData(
            this.geturl()
        );
    };

    handleSearchChange = (event) => {
        this.setState({ search: event.target.value }, this.searchLocal);
    };

    handleShortcodeChange = (event) => {
        this.setState({ shortcode: event.target.value }, this.searchLocal);
    };

    handleUsernameChange = (event) => {
        this.setState({ username: event.target.value }, this.searchLocal);
    };

    shouldRenderComponent = () => {
        return (
            this.props.user.startsWith('adib') ||
            this.props.user.startsWith('System') ||
            this.props.user.startsWith('mohannad')
        );
    };

    handleMoMessageChange = (id, content) => {
        const newData = [...this.state.data];
        const index = newData.findIndex((d) => d.id === id);
        newData[index] = { ...newData[index], mo_message: content };
        this.setState({ data: newData });
    }

    handleMtReplyMsgChange = (id, content) => {
        const newData = [...this.state.data];
        const index = newData.findIndex((d) => d.id === id);
        newData[index] = { ...newData[index], mt_reply_msg: content };
        this.setState({ data: newData });
    }

    exportTableToWord = () => {
        try {
            const table = document.getElementById('tableToExport');
            if (!table) {
                console.error('Table not found.');
                return;
            }

            const clonedTable = table.cloneNode(true);
            this.state.data.forEach((item, index) => {
                const row = clonedTable.rows[index];
                if (row) {
                    row.cells[2].innerText = item.mo_message; // Update the cell for mo_message
                    row.cells[3].innerText = item.mt_reply_msg; // Update the cell for mt_reply_msg
                }
            });

            const landscapeStyle = `
                <style>
                    @page { size: landscape; }
                    table { width: 100%; border-collapse: collapse; text-align: right; }
                    th, td { border: 1px solid black; }
                </style>
            `;

            const tableHtml = `
                <!DOCTYPE html>
                <html>
                    <head>
                        ${landscapeStyle}
                    </head>
                    <body>
                        ${clonedTable.outerHTML}
                    </body>
                </html>
            `;

            const docx = htmlToDocx.asBlob(tableHtml);
            saveAs(docx, 'table_export.docx');
        } catch (error) {
            console.error('Error exporting table:', error);
        }
    };
    render() {
        return (
            <React.Fragment>
                <br></br>    <br></br>
                {this.shouldRenderComponent() ? (
                    <div style={{ fontSize: '16pt' }}>
                        <div className="input-row">
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.search}
                                onChange={this.handleSearchChange}
                                placeholder="Search"
                            />
                            <select className="form-control" value={this.state.shortcode}
                                onChange={this.handleShortcodeChange} className="selectpicker">
                                <option value="" className="list-group-item">الكل</option>

                                <option value="4148" className="list-group-item">4148 أسود</option>
                                <option value="4142" className="list-group-item">4142 أسود</option>
                                <option value="4022" className="list-group-item">بنفسجي 4022 </option>
                                <option value="2337" className="list-group-item">2337  أزرق</option>
                                <option value="3900" className="list-group-item">زهري 3900</option>
                                <option value="6877" className="list-group-item">6877 بني</option>
                                <option value="4060" className="list-group-item">أصفر 4060</option>
                                <option value="6055" className="list-group-item">أخضر 6055</option>
                                <option value="2300" className="list-group-item">2300</option>
                                <option value="2304" className="list-group-item">2304 أحمر</option>
                                <option value="4024" className="list-group-item">أسود 4024</option>
                            </select>
                            <select className="selectpicker" value={this.state.username}
                                onChange={this.handleUsernameChange}>
                                <option value="" className="list-group-item">"الكل"</option>
                                <option value="adib" className="list-group-item">"أديب"</option>
                                <option value="System" className="list-group-item">"System"</option>

                                <option value="muraqeb" className="list-group-item">"muraqeb"</option>
                                <option value="muraqib" className="list-group-item">"muraqib"</option>
                                <option value="admin" className="list-group-item">"admin"</option>
                                <option value="mohannad" className="list-group-item">"منى"</option>
                                <option value="ammazen" className="list-group-item">"رزان"</option>
                                <option value="kordi" className="list-group-item">"kordi"</option>
                                <option value="omar" className="list-group-item">"عمر"</option>
                                <option value="bahaa" className="list-group-item">"بهاء"</option>
                                <option value="qabbani2" className="list-group-item">"qabbani2"</option>
                                <option value="test12" className="list-group-item">"test12"</option>
                                <option value="qabbani" className="list-group-item">"qabbani"</option>
                                <option value="qutaiba" className="list-group-item">"قتيبة"</option>
                                <option value="hasan" className="list-group-item">"hasan"</option>

                                <option value="kordi" className="list-group-item">"kordi"</option>
                            </select>
                        </div>
                        <div className="button-row">
                            <button onClick={this.searchLocal} className="btn btn-success">البحث</button>
                            <button onClick={this.searchApi} className="btn btn-danger">البحث من السيرفر</button>
                            <button onClick={this.searchApiBK} className="btn btn-danger">البحث من السيرفر البيانات القديمة</button>
                            <button onClick={this.exportTableToWord} className="btn btn-primary">حفظ كملف ورد</button>
                        </div>
                        {this.state.loading && (
                            <div className="loading-indicator-centered">
                                <p>جاري تحميل البيانات</p>
                            </div>
                        )}
                        <table id="tableToExport" className='table table-bordered flex-nowrap text-right'>
                            <thead>
                                <tr>
                                    <th>رقم</th>
                                    <th>المفسر</th>
                                    <th>GPT-قبل التعديل</th>
                                    <th>التفسير</th>
                                    <th>الحلم</th>
                                    {/* Add more table headers as needed */}
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.data.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.replyusername}</td>
                                        <td>{item.mufassermsg}</td>
                                        <td>{item.mt_reply_msg}</td>
                                        <td>{item.mo_message}</td>
                                        {/* Add more table data cells as needed */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p>Please enter a valid username to view the content.</p>
                )}
            </React.Fragment>
        );
    }

}

export default AdibApp;



// WEBPACK FOOTER //
// ./src/components/adib.jsx